import { render, staticRenderFns } from "./code-manage.vue?vue&type=template&id=794b7220&scoped=true"
import script from "./code-manage.vue?vue&type=script&lang=js"
export * from "./code-manage.vue?vue&type=script&lang=js"
import style0 from "./code-manage.vue?vue&type=style&index=0&id=794b7220&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794b7220",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('794b7220')) {
      api.createRecord('794b7220', component.options)
    } else {
      api.reload('794b7220', component.options)
    }
    module.hot.accept("./code-manage.vue?vue&type=template&id=794b7220&scoped=true", function () {
      api.rerender('794b7220', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/detail-pane/components/code-manage.vue"
export default component.exports